document.addEventListener('DOMContentLoaded', function () {

  const button = document.querySelector('#dm-mail-button');

  if (!button) {
    return;
  }

  button.addEventListener('click', function (event) {

    event.preventDefault();

    const vorname = document.querySelector('#dm-vorname')?.value.trim() || '';
    const nachname = document.querySelector('#dm-nachname')?.value.trim() || '';
    const telefon = document.querySelector('#dm-telefon')?.value.trim() || '';
    const nachricht = document.querySelector('#dm-nachricht')?.value.trim() || '';

    const einbauortElement =
      document.querySelector('input[name="dm-einbauort"]:checked');

    const einbauort =
      einbauortElement ? einbauortElement.value : '';


    if (!vorname || !nachname || !einbauort) {

      alert(
        'Bitte füllen Sie Vorname, Nachname und den Einbauort der Dichtung aus.'
      );

      return;
    }


    const betreff =
      'Dichtungsanfrage – ' + vorname + ' ' + nachname;


    const mailtext =
`Guten Tag liebes Dichtungsmax-Team,

ich benötige Hilfe bei der Suche nach einer passenden Dichtung.

Meine Kontaktdaten:
Vorname: ${vorname}
Nachname: ${nachname}
Telefonnummer: ${telefon || 'nicht angegeben'}

Angaben zur Dichtung:
Einbauort: ${einbauort}

Weitere Angaben:
${nachricht || 'keine weiteren Angaben'}

Falls vorhanden, füge ich dieser E-Mail Fotos meiner Dichtung als Anhang hinzu.

Mit freundlichen Grüßen
${vorname} ${nachname}`;


    const mailto =
      'mailto:info@dichtungsmax.de?subject=' +
      encodeURIComponent(betreff) +
      '&body=' +
      encodeURIComponent(mailtext);


    window.location.href = mailto;

  });

});